module.exports = __webpack_public_path__ + "static/img/info2.dbf4ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/supplyDetail/info2.png
// module id = zlrv
// module chunks = 44